/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight, MdSearch } from "react-icons/md";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../RecasUserTable/RecasUserTable.css";
import Select from "react-select";
import moment from "moment";
import Loader from "../../../../Components/loader/loader";
import { toast } from "react-toastify";

const RecasUserTable = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const LoginToken = GetToken();

  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [specificUserId, setSpecificUserId] = useState(null);
  const [getAllUser, setGetAllUser] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [monthStartDate, setMonthStartDate] = useState("");
  const [monthEndDate, setMonthEndDate] = useState("");

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getMonthStartEndDates = (year, monthIndex) => {
    const startDate = moment(new Date(year, monthIndex)).format("YYYY/MM/DD");
    const endDate = moment(new Date(year, monthIndex + 1, 0)).format(
      "YYYY/MM/DD"
    );

    return {
      startDate,
      endDate,
    };
  };

  const monthOptions = monthNames.map((month, index) => ({
    label: month,
    value: index + 1,
    dates: getMonthStartEndDates(new Date().getFullYear(), index),
  }));

  const GetAllUser = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Recas/GetAllUsers`,
    };

    axios(option)
      .then((e) => {
        const allData = JSON.parse(e?.data?.data);
        setGetAllUser(allData?.Result || []);
      })
      .catch(() => {
        setGetAllUser([]);
      });
  };

  const GetProjectData = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Recas/GetAllProjects`,
    };

    axios(option)
      .then((e) => {
        const projectData = JSON.parse(e?.data?.data);
        setProjectDetails(projectData?.Result || []);
      })
      .catch(() => {
        setProjectDetails([]);
      });
  };

  useEffect(() => {
    GetAllUser();
    GetProjectData();
  }, []);

  useEffect(() => {
    if (getAllUser?.length) {
      setLeaveRequestDuplicate(getAllUser);
      setFilteredUsers(getAllUser);
    } else {
      setLeaveRequestDuplicate([]);
      setFilteredUsers([]);
    }
  }, [getAllUser]);

  const handleshowHolidayModal = (user) => {
    const resolvedUserId =
      user?.RecasUserId ?? user?.UserId ?? user?.Id ?? user?.id ?? null;

    if (!resolvedUserId) {
      toast.error("UserId not found");
      return;
    }

    setSpecificUserId(resolvedUserId);
    setProjectId("");
    setMonthStartDate("");
    setMonthEndDate("");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setProjectId("");
    setMonthStartDate("");
    setMonthEndDate("");
    setSpecificUserId(null);
  };

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase()?.trim();

    if (!searchTerm) {
      setFilteredUsers(getAllUser);
      return;
    }

    const filteredData = getAllUser.filter(
      (item) =>
        item?.UserName?.toLowerCase()?.includes(searchTerm) ||
        item?.Department?.toLowerCase()?.includes(searchTerm) ||
        item?.Designation?.toLowerCase()?.includes(searchTerm)
    );

    setFilteredUsers(filteredData);
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

    setShowSidebar(true);
  }, []);

  const handleSubmitModel = () => {
    if (!specificUserId) {
      toast.error("UserId is required");
      return;
    }

    if (!monthStartDate || !monthEndDate) {
      toast.error("Month is required");
      return;
    }

    if (!projectId) {
      toast.error("Project is required");
      return;
    }

    setLoading(true);

    const data = {
      UserId: specificUserId,
      StartDate: monthStartDate,
      EndDate: monthEndDate,
      ProjectId: projectId,
    };

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Recas/ScreenCaptures`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);

        const responseData = e?.data?.data;
        const verifyData = JSON.parse(responseData);

        if (e?.status === 200) {
          toast.success(e?.data?.message || "Data fetched successfully");
          setShowModal(false);
          navigate("/Adm/RecasScreenshot", { state: { data: verifyData } });
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error("No Data Found");
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-Attendance-Holiday"
              : "main-container-of-all-employees-page-new-Attendance-management"
          }
        >
          <div className="inner-container-of-all-employees-page-Holiday">
            <div className="header-of-employees-page-Holiday row">
              <div className="all-employee-Attendance-Holiday col">
                <h4>Recas</h4>
              </div>

              <div className="all-employees-Attendance-Holiday col">
                <div className="home-icon-Attendance-Holiday">
                  <BiHomeAlt className="home-icon-header-Attendance-Holiday" />
                </div>

                <div className="arrow-icon-Attendance-Holiday">
                  <MdKeyboardArrowRight />
                </div>

                <div className="employee-text-Attendance-Holiday">
                  <p>Recas</p>
                </div>

                <div className="arrow-icon-Attendance-Holiday">
                  <MdKeyboardArrowRight />
                </div>

                <div className="all-employee-text-Attendance-Holiday">
                  <p>Recas</p>
                </div>
              </div>
            </div>
          </div>

          <div className="body-part-outer-Attendance-Holiday">
            <div className="inner-body-container-of-employee-Attendance-Holiday row-12">
              <div className="first-side-in-body-Attendance-Holiday col-6">
                <div className="employee-text-in-Attendance-Holiday">
                  <h2>Recas</h2>
                </div>

                <div className="input-for-search-in-employee-Attendance-Holiday recas-search-wrap">
                  <MdSearch className="search-icon-in-Attendance-Holiday" />
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={handleDataSearch}
                  />
                </div>
              </div>
            </div>

            <div className="table-in-all-emplyee-Attendance-Holiday recas-table-outer">
              <div className="recas-table-scroll">
                <table className="table-main-Attendance-Holiday">
                  <thead className="thead-main-Attendance-Holiday">
                    <tr className="row-12">
                      <th className="image-class-Holiday col-2">Sr. no</th>
                      <th className="image-class-Holiday col-2">Person Name</th>
                      <th className="image-class-Holiday col-2">Department</th>
                      <th className="image-class-Holiday col-2">Designation</th>
                      <th className="image-class-Holiday col-2">Action</th>
                    </tr>
                  </thead>

                  {filteredUsers?.length ? (
                    <tbody className="tbody-main-Attendance-Holiday">
                      {filteredUsers
                        ?.sort((a, b) =>
                          (a?.UserName || "").localeCompare(b?.UserName || "")
                        )
                        ?.map((item, index) => (
                          <tr key={item?.Id || item?.UserId || index}>
                            <td>{index + 1}</td>
                            <td>{item?.UserName || "-"}</td>
                            <td>{item?.Department || "-"}</td>
                            <td>{item?.Designation || "-"}</td>
                            <td>
                              <button
                                className="screenshot-button"
                                onClick={() => handleshowHolidayModal(item)}
                              >
                                View Activity
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td
                          className="no-data-avilable-on-this-table"
                          colSpan="5"
                        >
                          No data available
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header closeButton onHide={handleCloseModal}>
              <Modal.Title>Recas</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="addemp-react-select-input">
                <label>Month</label>
                <Select
                  classNamePrefix="EMP-leave-request-input"
                  placeholder="Select Month"
                  options={monthOptions}
                  onChange={(selectedOption) => {
                    if (selectedOption?.dates) {
                      setMonthStartDate(selectedOption.dates.startDate);
                      setMonthEndDate(selectedOption.dates.endDate);
                    } else {
                      setMonthStartDate("");
                      setMonthEndDate("");
                    }
                  }}
                />
              </div>

              <div className="addemp-react-select-input">
                <label>Project</label>
                <Select
                  classNamePrefix="EMP-leave-request-input"
                  placeholder="Select Project"
                  options={projectDetails?.map((project) => ({
                    value: project?.Id,
                    label: project?.Name,
                  }))}
                  onChange={(selectedOption) =>
                    setProjectId(selectedOption?.value || "")
                  }
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                className="Delete-modal-close-button"
                onClick={handleCloseModal}
              >
                Close
              </button>

              <button
                className="Delete-modal-delete-button"
                onClick={handleSubmitModel}
              >
                Submit
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};

export default RecasUserTable;